import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoLoadingIndicator from '../loading-indicator/pendo-loading-indicator.vue.js';
import { setStyles } from '../../utils/dom.js';

var script = {
  components: {
    PendoIcon,
    PendoLoadingIndicator
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean
    },
    invalid: {
      type: Boolean
    },
    isFocused: {
      type: Boolean
    },
    isFullWidth: {
      type: Boolean
    },
    isOpen: {
      type: Boolean
    },
    isSearchable: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    maxTriggerWidth: {
      type: [String, Number]
    },
    minTriggerWidth: {
      type: [String, Number]
    },
    triggerSize: {
      type: String
    }
  },
  data() {
    return {
      hover: false
    };
  },
  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        this.$el.focus();
      }
    },
    minTriggerWidth() {
      setStyles(this.$refs.trigger, {
        minWidth: this.isFullWidth ? '100%' : this.minTriggerWidth
      });
    },
    maxTriggerWidth() {
      setStyles(this.$refs.trigger, {
        maxWidth: this.maxTriggerWidth
      });
    }
  },
  mounted() {
    setStyles(this.$refs.trigger, {
      minWidth: this.isFullWidth ? '100%' : this.minTriggerWidth,
      maxWidth: this.maxTriggerWidth
    });
  },
  methods: {
    onMouseenter(event) {
      this.hover = true;
      this.$emit('mouseenter', event);
    },
    onMouseleave(event) {
      this.hover = false;
      this.$emit('mouseleave', event);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-multiselect-trigger.vue2.js.map
